import React, { useContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import styled from "styled-components";
import Farm from "../../Pages/Farm/Farm";
import Home from "../../Pages/Home/Home";
import NftsDetailPage from "../../Pages/NftsDetailPage/NftsDetailPage";
import Pool from "../../Pages/Pool/Pool";
import * as Router from "../../Routes";
import LeftsideBar from "./LeftSideBar";

import TrendingNfts from "../../Pages/NftMarket/TrendingNfts/TrendingNfts";
import AuctionNft from "../../Pages/NftMarket/AuctionedNft/AuctionNft";
import DetailNft from "../../Pages/NftMarket/AuctionedNft/DetailNft";
import NftCategories from "../../Pages/NftMarket/NftCategories/NftCategories";
import Nftspecifichomepage from "../../Pages/NftMarket/NftSpecificPage.js/Nftspecifichomepage";
import BuyNow from "../../Pages/NftMarket/BuyNowPopUp/BuyNow";
import NftMarket from "../../Pages/NftMarket/NftMarketPage/NftMarket";
import MyNfts from "../../Pages/NftMarket/MyNfts/MyNfts";
import LoginLogoutComponent from "../WalletComponents/LoginLogoutComponent";
import ScrollToTop from "../ScrollToTop";
import ViewNftComponent from "../../Pages/NftMarket/MyNfts/ViewNftComponent";
import NFTDetailPage from "../../Pages/NftMarket/NftSpecificPage.js/NftDetailPage";
import TransactionHistory from "../../Pages/Transactionhistory/TransactionHistory";
import PaymentRedirectPage from "../PaymentRedirectPage";
import { userBalanceContext } from "../../context/userBalanceContext";
import environmentVariables from "../../config/environmentVariables";

const LeftSideImage = `${environmentVariables?.cdnUrl}mainpageLeftBg.png`
const RightSideImage = `${environmentVariables?.cdnUrl}mainpageRightbg.png`

const Root = styled.div`
  width: 100%;
  min-height: 100vh;
  color: ${(p) => p.theme.colors.white};
  position: relative;
  font-family: ${(p) => p.theme.font.family.Lato};
  font-stretch: normal;
  font-style: normal;
`;


const Container = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: row;
  z-index: 11;
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    flex-direction: column-reverse;
  }
`;
const Div = styled.div`
  width: 100%;
`;
const LeftImage = styled.img`
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: -1;
  width: fit-content;
  height: 500px;
  @media (max-width: ${(p) => p.theme.screen.xxs}) {
    height: 300px;
  }
`;
const RightImage = styled.img`
  position: fixed;
  right: 0px;
  z-index: -1;
  width: fit-content;
  bottom: 0px;
  height: 500px;
  @media (max-width: ${(p) => p.theme.screen.xxs}) {
    height: 300px;
  }
`;
const App = () => {
  const [showNavigation, setShowNavigation] = useState(false);
  const [callFun, setCallFun] = useState(false);
  const [allContractDetails, setAllContractDetails] = useState(null);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  useEffect(() => {
    if (showNavigation) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [showNavigation]);
  return (
    <Root
      onClick={() => {
        setShowNavigation(false);
        setIsNotificationOpen(false);
      }}
    >
      <Container>
        <ScrollToTop />
        <LeftImage src={LeftSideImage} />
        <RightImage src={RightSideImage} />
        <LeftsideBar 
          showNavigation={showNavigation}
          callFun={callFun}
          setShowNavigation={setShowNavigation}
          allContractDetails={allContractDetails}
          setAllContractDetails={setAllContractDetails}
        />
        <Routes>
          <Route path={Router.PAYMENT} element={<PaymentRedirectPage />} />
        </Routes>
        {/* <Div style={{ overflow: "auto" }}> */}
        <Div style={{ overflow: showNavigation ? "hidden" : "auto" }}>
          <LoginLogoutComponent
            allContractDetails={allContractDetails}
            setAllContractDetails={setAllContractDetails}
            isNotificationOpen={isNotificationOpen}
            setIsNotificationOpen={setIsNotificationOpen}
          />
          <Routes>
            <Route
              path={Router.HOME}
              element={
                <Home
                  allContractDetails={allContractDetails}
                  setAllContractDetails={setAllContractDetails}
                />
              }
            />
            <Route
              path={Router.POOL}
              element={<Pool setAllContractDetails={setAllContractDetails} allContractDetails={allContractDetails} />}
            />
            <Route
              path={Router.FARM}
              element={
                <Farm
                setAllContractDetails={setAllContractDetails}
                  allContractDetails={allContractDetails}
                  setCallFun={setCallFun}
                />
              }
            />
            <Route
              path={Router.NFTMARKET}
              element={<NftMarket allContractDetails={allContractDetails} />}
            />
           
            <Route path={Router.NFTDETAIL} element={<NftsDetailPage />} />
            
            <Route
              path={Router.TRENDINGNFTS}
              element={<TrendingNfts allContractDetails={allContractDetails} />}
            />
            <Route
              path={Router.AUCTIONNFT}
              element={<AuctionNft allContractDetails={allContractDetails} />}
            />
           
            <Route
              path={Router.DETAILNFT}
              element={<DetailNft allContractDetails={allContractDetails} />}
            />
            <Route
              path={Router.DETAILNFTID}
              element={<DetailNft allContractDetails={allContractDetails} />}
            />
            <Route
              path={Router.NFTCATEGORIES}
              element={
                <NftCategories allContractDetails={allContractDetails} />
              }
            />
            <Route
              path={Router.NFTCATEGORIESID}
              element={
                <NftCategories allContractDetails={allContractDetails} />
              }
            />
            <Route
              path={Router.NFTSPECIFICPAGE}
              element={
                <Nftspecifichomepage
                  setAllContractDetails={setAllContractDetails}
                  allContractDetails={allContractDetails}
                />
              }
            />
            <Route
              path={Router.NFTSPECIFICPAGEID}
              element={
                <Nftspecifichomepage
                  setAllContractDetails={setAllContractDetails}
                  allContractDetails={allContractDetails}
                />
              }
            />
            <Route path={Router.BUYNOW} element={<BuyNow />} />
            <Route
              path={Router.MyNFTS}
              element={<MyNfts allContractDetails={allContractDetails} />}
            />
            <Route
              path={Router.VIEWNFT}
              element={
                <ViewNftComponent allContractDetails={allContractDetails} />
              }
            />
            <Route
              path={Router.NFTDETAILVIEW}
              element={
                <NFTDetailPage
                  allContractDetails={allContractDetails}
                  setAllContractDetails={setAllContractDetails}
                />
              }
            />
            <Route
              path={Router.TRANSACTIONHISTORY}
              element={
                <TransactionHistory allContractDetails={allContractDetails} />
              }
            />
            <Route path="*" element={<Home />} />
          </Routes>
        </Div>
      </Container>
    </Root>
  );
};

export default App;
